import ExpandedSection from './ExpandedSection';
import { toTestIdPart } from '../../utils/testIds';
import './packageDetailsSection.css';

type PackageDetailsSectionProps = {
  chevronSrc: string;
  details: ReadonlyArray<readonly [string, string]>;
};

export default function PackageDetailsSection({ chevronSrc, details }: PackageDetailsSectionProps) {
  return (
    <ExpandedSection title="Package Details" chevronSrc={chevronSrc} testId="landing-package-details-toggle" cardClassName="rid-package-details">
      {details.map(([label, value]) => {
        const rowId = toTestIdPart(label, 'detail');
        return (
          <div className="rid-package-details__kv" key={label} data-testid={`landing-package-detail-row-${rowId}`}>
            <span data-testid={`landing-package-detail-label-${rowId}`}>{label}</span>
            <strong data-testid={`landing-package-detail-value-${rowId}`}>{value}</strong>
          </div>
        );
      })}
    </ExpandedSection>
  );
}
